import { Component, inject, resource } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BbitWebsiteService, I18nPipe } from '@bbitgmbh/website.sdk';
import { DateTime } from 'luxon';
import { LoadingComponent } from '../../helper/loading/loading.component';
import { IBbitCampsiteBookingPeriod, IBbitCampsiteBookingPeriodResponse } from '../camping.interfaces';

@Component({
  selector: 'app-camping-selection',
  imports: [I18nPipe, LoadingComponent, RouterLink],
  templateUrl: './camping-selection.component.html',
  styleUrl: './camping-selection.component.scss',
})
export class CampingSelectionComponent {
  private _website = inject(BbitWebsiteService);

  public periods = resource<IBbitCampsiteBookingPeriodResponse, void>({
    loader: async () => {
      const response = await fetch(`${this._website.getBlApiUrl()}/campsite/bookingPeriods`, {
        method: 'GET',
        headers: {
          Authorization: `${this._website.getAccessToken()}`,
        },
      });

      if (!response.ok) {
        throw new Error('call failed');
      }

      const result = await response.json();

      return result.sort((a: IBbitCampsiteBookingPeriod, b: IBbitCampsiteBookingPeriod) =>
        a.from.localeCompare(b.from),
      );
    },
  });

  formatDate(date: string): string {
    return DateTime.fromISO(date).toFormat('dd.LL.yyyy HH:mm');
  }
}
